import { countryNameById, regionNameById, settlementNameById } from "../full-address-string";

import { AddressDetailResponse } from "@app/shared/models/chip-details.model";
import { Content } from "pdfmake/interfaces";

export function addressContent(address: AddressDetailResponse | undefined): Content[] {
    return address
        ? [
              {
                  table: {
                      widths: ['auto', '*', 'auto', '*', 'auto', '*'],
                      body: [
                          [
                              { text: 'Adresa', border: [false, false, false, false] },
                              {
                                  text: address.address || '',
                                  colSpan: 3,
                                  border: [false, false, false, true],
                              },
                              '',
                              '',
                              { text: 'Kodi postar', border: [false, false, false, false] },
                              {
                                  text: address.zipCode,
                                  border: [false, false, false, true],
                              },
                          ],
                          [
                              { text: 'Shteti', border: [false, false, false, false] },
                              {
                                  text: countryNameById(address.countryId),
                                  border: [false, false, false, true],
                              },
                              { text: 'Rajoni', border: [false, false, false, false] },
                              {
                                  text: regionNameById(address.regionId),
                                  border: [false, false, false, true],
                              },
                               { text: 'Vendbanimi', border: [false, false, false, false] },
                              {
                                  text: settlementNameById(address.settlementId),
                                  border: [false, false, false, true],
                              },
                          ],
                      ],
                  },
                  margin: [0, 2, 0, 10],
                  layout: {
                      defaultBorder: false,
                  },
              },
          ]
        : [];
}
